import { cn } from '@/lib/utils.ts';

type Props = {
  className?: string;
};

export default function Hr({ className }: Props) {
  return <hr className={cn('border-hydrangea-100 my-6', className)} />;
}
